import { WhiteLabelTitle } from 'types/models/white-label';

import getWhiteLabelConfig from './get-white-label-config';

export function isRanchbot() {
  const { title: whiteLabel } = getWhiteLabelConfig();
  return whiteLabel === WhiteLabelTitle.RANCHBOT;
}

export function isFarmbot() {
  const { title: whiteLabel } = getWhiteLabelConfig();
  return whiteLabel === WhiteLabelTitle.FARMBOT;
}

/**
 * Returns the white-label Toolkit app name.
 * Around the codebase this is also referred to as the "Bluetooth app" and "Trough Direct app".
 */
export function getToolkitAppName() {
  return isRanchbot() ? 'Ranchbot Toolkit' : 'Farmbot Toolkit';
}
